import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import GenericSidebar from "./GenericSidebar";

const GenericSidebarPortal = (props) => {
    const contentElRef = useRef(document.createElement("div"));

    useEffect(() => {
        const sidebarEl = document.getElementById("divPageSidebar");
        const contentEl = contentElRef.current;

        sidebarEl.append(contentEl);

        return () => {
            contentEl.remove();
        };
    }, []);

    return createPortal(
        <GenericSidebar {...props} includeTheme={false} />,
        contentElRef.current
    );
};

GenericSidebarPortal.propTypes = {
    open: PropTypes.bool,
    content: PropTypes.node,
    onClose: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
    children: PropTypes.node,
};

export default GenericSidebarPortal;
